var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{scopedSlots:_vm._u([{key:"titleBreadcrumb",fn:function({ messageProps }){return [_c('div',[_c('div',[_c('h1',[_vm._v(_vm._s(messageProps))])]),_vm._t("onlybreadcrumb")],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }